import React from 'react';
import AdminHeader from "./AdminHeader"

const Admin = () => {
    return (
        <div>
            
            <AdminHeader></AdminHeader>
            <h1>This is Admin</h1>
        </div>
    );
};

export default Admin;